import React from 'react';
import { Instagram, Facebook, Twitter, Youtube, Mail, MapPin } from 'lucide-react';
import { coachData, contactInfo } from '../data/mockData';
import '../styles/footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { label: 'Home', href: '#home' },
    { label: 'About', href: '#about' },
    { label: 'Journey', href: '#journey' },
    { label: 'Programs', href: '#programs' },
    { label: 'Testimonials', href: '#testimonials' },
    { label: 'Contact', href: '#contact' }
  ];

  const programs = [
    'Elite Batting Academy',
    'Wicket-Keeping Masterclass',
    'Junior Cricket Foundation',
    'Match Preparation'
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="container">
          <div className="footer-grid">
            {/* Brand Column */}
            <div className="footer-column footer-brand">
              <img 
                src={coachData.logo} 
                alt="ClutchCricket" 
                className="footer-logo"
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              />
              <p className="footer-description">
                Championship-level cricket coaching by Karnataka first-class cricketer KV Siddharth. Transform your game with professional expertise.
              </p>
              <div className="social-links">
                <a href={contactInfo.socialMedia.instagram} target="_blank" rel="noopener noreferrer" className="social-link">
                  <Instagram size={20} />
                </a>
                <a href={contactInfo.socialMedia.facebook} target="_blank" rel="noopener noreferrer" className="social-link">
                  <Facebook size={20} />
                </a>
                <a href={contactInfo.socialMedia.twitter} target="_blank" rel="noopener noreferrer" className="social-link">
                  <Twitter size={20} />
                </a>
                <a href={contactInfo.socialMedia.youtube} target="_blank" rel="noopener noreferrer" className="social-link">
                  <Youtube size={20} />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div className="footer-column">
              <h4 className="footer-title">Quick Links</h4>
              <ul className="footer-links">
                {quickLinks.map((link, index) => (
                  <li key={index}>
                    <a href={link.href} onClick={(e) => scrollToSection(e, link.href)}>
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Programs */}
            <div className="footer-column">
              <h4 className="footer-title">Programs</h4>
              <ul className="footer-links">
                {programs.map((program, index) => (
                  <li key={index}>
                    <a href="#programs" onClick={(e) => scrollToSection(e, '#programs')}>
                      {program}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Info */}
            <div className="footer-column">
              <h4 className="footer-title">Contact</h4>
              <ul className="footer-contact">
                <li>
                  <Mail size={16} />
                  <a href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a>
                </li>
                <li>
                  <MapPin size={16} />
                  <span>{contactInfo.address}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p className="copyright">
              © {currentYear} ClutchCricket. All rights reserved.
            </p>
            <div className="footer-bottom-links">
              <a href="#privacy">Privacy Policy</a>
              <span className="divider">•</span>
              <a href="#terms">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
